import ApiRequestManagerInstance from '../ApiRequestManager';

function removeKeepWatching(id: string) {
  const promise = new Promise<boolean>(async (resolve) => {
    try {
      await ApiRequestManagerInstance.delete({
        endpoint: {
          url: 'apiUrl',
          version: 'v4',
          section: 'media',
          subsection: 'later',
          type: 'later',
          params: id,
        },
      });
      resolve(true);
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });

  return promise;
}

export default removeKeepWatching;
